<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent class="demo-form-inline">
            <el-form-item label="app版本：">
                <el-input v-model="searchForm.appVersion" placeholder="请输入" @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item label="新/旧版本：">
                <el-select v-model="searchForm.isNew" placeholder="请选择" clearable>
                    <el-option label="新版本" value="1"></el-option>
                    <el-option label="旧版本" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="系统类型：">
                <el-select v-model="searchForm.systemType" placeholder="请选择" clearable>
                    <el-option label="iOS" value="0"></el-option>
                    <el-option label="Android" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button type="primary" @click="appVersionVisible = true">版本上传</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="appVersion" label="app版本"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="版本">
                <template slot-scope="scope">
                    {{ scope.row.isNew == 1 ? '最新版本' : '旧版本' }}
                </template>
            </el-table-column>
            <el-table-column label="系统类型">
                <template slot-scope="scope">
                    {{ scope.row.systemType == 1 ? 'Android' : 'iOS' }}
                </template>
            </el-table-column>
            <el-table-column prop="url" label="链接地址"></el-table-column>
            <el-table-column prop="versionRemark" label="备注"></el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <el-dialog title="版本上传" :visible.sync="appVersionVisible" append-to-body width="600px" @close='uploadClose'>
            <el-form :model="uploadForm" label-width='120px' :rules="appVersionRules" ref="uploadForm">
                <el-form-item label="app版本：" prop="appVersion">
                    <el-input v-model="uploadForm.appVersion" ></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="versionRemark">
                    <el-input v-model="uploadForm.versionRemark" ></el-input>
                </el-form-item>
                <el-form-item label="链接地址：" prop="url">
                    <el-input v-model="uploadForm.url" ></el-input>
                </el-form-item>
                <el-form-item label="是否最新版本：" prop="isNew">
                    <el-select v-model="uploadForm.isNew" placeholder="请选择">
                        <el-option label="新版本" value="1"></el-option>
                        <el-option label="旧版本" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="系统类型：" prop="systemType">
                    <el-select v-model="uploadForm.systemType" placeholder="请选择">
                        <el-option label="iOS" value="0"></el-option>
                        <el-option label="Android" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="uploadClose">取 消</el-button>
                <el-button type="primary" @click="sureUpload">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import common from '@/utils/common.js'
import request from '@/utils/request.js'
export default {
    data(){
        return {
            searchForm: {
                appVersion: '',
                isNew: '',
                systemType: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                 
            },
            appVersionVisible: false,
            uploadForm: {
                appVersion: '',
                versionRemark: '',
                isNew: '',
                url: '',
                systemType: ''
            },
            appVersionRules: {
                appVersion: [{ required: true, message: '请输入版本', trigger: 'blur' }],
                versionRemark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
                isNew: [{ required: true, message: '请选择', trigger: 'change' }],
                url: [{ required: true, message: '请输入链接地址', trigger: 'blur' }],
                systemType: [{ required: true, message: '请选择', trigger: 'change' }],
            }
        }
    },
    methods: {
        onSubmit($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            let data = common.getRequestParams(this, 'tbpg', this.searchForm);
            request({
                url: 'xxtx/app/version/info',
                method: 'post',
                data,
                headers: {
                    appid: '1'
                }
            }).then(res => {
                this.tbpg.tableData = res.data.data;
                this.tbpg.total = res.data.data.length;
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.onSubmit();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.onSubmit();
        },
        uploadClose(){
            this.appVersionVisible = false;
            this.$refs.uploadForm.resetFields();
        },
        sureUpload(){
            this.$refs.uploadForm.validate((valid) => {
                if (valid) {
                    request({
                        url: 'xxtx/app/version',
                        method: 'post',
                        data: this.uploadForm,
                        headers: {
                            appid: '1'
                        }
                    }).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message)
                            this.onSubmit();
                        }else {
                            this.$message.error(res.data.message)
                        }
                    })
                    this.appVersionVisible = false;
                }
            })
        }
    },
    created(){
        this.onSubmit();
    }
}
</script>

<style>

</style>